<div (click)="toggleDropdown()"
    class="c-profile-menu__button">
    <pay-avatar [user]="user" *ngIf="!!user"
        [isSingleInitial]="true"
        [class.c-avatar--admin]="isAdmin"
        [class.c-avatar--manager]="isManager">
    </pay-avatar>
</div>

<pay-pop [(show)]="showDropdown"
    [alignment]="ALIGNMENT"
    [direction]="DIRECTION"
    [modal]="true"
    class="c-profile-menu__popover"
    (onBackdropClick)="toggleDropdown()"
    [width]="365"
    [gap]="8"
    [arrow]="false">

    <ng-template>
        
        <div class="c-profile-menu__first" [class.is-active]="!showCompanyList">
            <div class="c-profile-menu__header">
                <div class="c-profile-menu__header-wrapper">
                    <pay-avatar class="mr-3"
                        [isSingleInitial]="true"
                        [class.c-avatar--admin]="isAdmin"
                        [class.c-avatar--manager]="isManager"
                        [user]="company"></pay-avatar>
            
                    <div class="c-profile-menu__company">
                        {{ company?.name | payStrSlice: 30 }}
                    </div>
                </div>
            </div>

            <div class="c-profile-menu__divider"></div>
    
            <div class="c-list mt-3">
    
                <div class="c-list__item x-profile-menu-item c-list__item--rounded" *ngIf="hasMultipleCompanies"
                    (click)="toggleCompanyList()">

                    <div class="c-profile-menu__item-wrapper">
                        <pay-icon name="user-rounded"></pay-icon>
                        {{ 'Profile.Menu.SwitchAccount' | translate }}
    
                        <button payIconButton
                            class="x-profile-menu-action-icon ml-auto c-icon-btn--sm"
                            icon="alt-arrow-right"
                            (click)="toggleCompanyList()"></button>
                    </div>
                </div>
                <div class="c-list__item x-profile-menu-item c-list__item--rounded" (click)="goToHelp()">
                    <div class="c-profile-menu__item-wrapper">
                        <pay-icon name="question-square" class="x-nav-bar-sub-menu-item-icon"></pay-icon>
                        {{ 'Profile.Menu.HelpGuide' | translate }}
                        <pay-icon name="alt-arrow-right" class="ml-auto c-icon--sm mr-2"></pay-icon>
                    </div>
                </div>
                <div class="c-list__item x-profile-menu-item c-list__item--rounded" (click)="goToFeedback()">
                    <div class="c-profile-menu__item-wrapper">
                        <pay-icon name="chat-square-arrow" class="x-nav-bar-sub-menu-item-icon"></pay-icon>
                        {{ 'Profile.Menu.GiveUsFeedback' | translate }}
                        <pay-icon name="alt-arrow-right" class="ml-auto c-icon--sm mr-2"></pay-icon>
                    </div>
                </div>
                <div class="c-list__item x-profile-menu-item c-list__item--rounded" (click)="logout()">
                    <div class="c-profile-menu__item-wrapper">
                        <pay-icon name="exit" class="x-nav-bar-sub-menu-item-icon"></pay-icon>
                        {{ 'Profile.Menu.LogOut' | translate }}
                    </div>
                </div>
            </div>
        </div>
        <div class="c-profile-menu__second" [class.is-active]="showCompanyList">

            <div class="c-profile-menu__header">
                <div class="c-profile-menu__header-wrapper">
                    <button payIconButton
                        class="c-icon-btn--base mr-3"
                        icon="arrow-left"
                        (click)="toggleCompanyList()"></button>
                
                    <div>
                        <div class="c-profile-menu__company">
                            {{ 'Profile.Menu.Accounts' | translate }}
                        </div>
                    </div>
                </div>
            </div>

            <div class="c-profile-menu__divider"></div>

            <pay-company-selector (companyChangeCompleted)="toggleCompanyList()"></pay-company-selector>
        </div>
        
    </ng-template>
</pay-pop>
